// nodes created or restored by Matreshka.Array rendering
// a WeakMap, as IE 11 has no WeakSet
export default new WeakMap();